module.exports = "https://portperrypedals.ca/_res/img/grandview.45313c4.jpg";